import { Upload, BarChart3, FileCheck2 } from "lucide-react";
import { useReveal } from "../../lib/animations";
import { useHomepageContent } from "@/lib/homepageContent";

// Visual-only metadata (icon + step number) zipped onto the editable steps by index.
const stepMeta = [
  { n: "01", icon: Upload },
  { n: "02", icon: BarChart3 },
  { n: "03", icon: FileCheck2 },
];

export default function HowItWorks() {
  const ref = useReveal();
  const { howItWorks } = useHomepageContent();
  const steps = howItWorks.steps.map((s, i) => ({ ...stepMeta[i], ...s }));
  return (
    <section data-testid="how-it-works" className="oc-section bg-white">
      <div ref={ref} className="oc-reveal oc-container">
        <div className="max-w-5xl">
          <span className="inline-flex items-center gap-2 text-[13px] uppercase tracking-[0.1em] font-semibold text-oc-secondary">
            <span className="w-1.5 h-1.5 rounded-full bg-oc-fair" />
            {howItWorks.eyebrow}
          </span>
          <h2 className="font-display font-bold text-[28px] sm:text-[36px] lg:text-[42px] leading-tight tracking-tight text-oc-primary mt-3 whitespace-normal lg:whitespace-nowrap">
            {howItWorks.heading}
          </h2>
          <p className="mt-4 text-oc-textSecondary text-[17px] leading-relaxed">
            {howItWorks.intro}
          </p>
        </div>

        <div className="mt-16 grid md:grid-cols-3 gap-6">
          {steps.map((s, i) => {
            const Icon = s.icon;
            const isGreen = i === 1; // middle step gets the green accent
            return (
              <div
                key={i}
                data-testid={`step-${i + 1}`}
                className="group bg-white rounded-oc border border-oc-border p-10 transition-all duration-300 hover:-translate-y-1 hover:shadow-oc-card-hover relative overflow-hidden"
                style={{ animation: `fade-in-up 600ms ease-out both ${i * 120}ms` }}
              >
                {/* tiny accent bar */}
                <span className={`absolute top-0 left-0 h-[3px] w-12 rounded-r-full transition-all duration-300 group-hover:w-24 ${isGreen ? "bg-oc-fair" : "bg-oc-secondary"}`} />
                <div className="flex items-center justify-between">
                  <span className="font-mono text-[13px] tracking-[0.1em] text-oc-textSecondary">{s.n}</span>
                  <div className={`w-12 h-12 rounded-xl flex items-center justify-center transition-colors ${isGreen ? "bg-oc-fair/10 text-oc-fair group-hover:bg-oc-fair group-hover:text-white" : "bg-oc-subtle text-oc-primary group-hover:bg-oc-primary group-hover:text-white"}`}>
                    <Icon className="w-5 h-5" strokeWidth={2} />
                  </div>
                </div>
                <h3 className="font-display font-semibold text-[22px] text-oc-primary mt-8 leading-snug">
                  {s.title}
                </h3>
                <p className="mt-3 text-oc-textSecondary leading-relaxed">{s.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
